module.exports = __webpack_public_path__ + "img/icon_card011.b929e896.png";